module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0012.jpg?v=41114215";